import { getSummaryReportId } from "Areas/Sidebar/SummaryReports";
import { getBackUrlHash } from "Areas/Sidebar/switcher/redux/selectors";
import { connect } from "react-redux";
import { getData } from "../redux/selectors";
import ActionPanel from "./actionPanel";
const mapStateToProps = (state) => {
    var _a;
    return ({
        summaryReportId: getSummaryReportId(state),
        summaryReportName: (_a = getData(state)) === null || _a === void 0 ? void 0 : _a.Name,
        backUrlHash: getBackUrlHash(state)
    });
};
export default connect(mapStateToProps)(ActionPanel);
